import axios from "axios";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Head = () => {
  useEffect(() => {
    const loadWebFont = () => {
      const WebFont = window.WebFont;
      WebFont.load({
        google: {
          families: [
            "Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic",
            "Inter:100,200,300,regular,500,600,700,800,900,100italic,200italic,300italic,italic,500italic,600italic,700italic,800italic,900italic",
          ],
        },
      });
    };

    const script = document.createElement("script");
    script.src =
      "https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js";
    script.async = true;
    script.onload = loadWebFont;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const getDeviceType = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|tablet/i.test(userAgent)) {
      return "mobile";
    }
    return "web"; // Default to web if not mobile/tablet
  };

  const refresh_token = localStorage.getItem("@userRefreshToken");
  const accessToken = localStorage.getItem("@user");
  async function getAccessToken() {
    try {
      const response = await axios.post(
        "https://htprdapi.hightable.ai/oauth/token",
        {
          refresh_token: refresh_token,
          client_id: "CLIENT002",
          client_secret: "5PY02KdOpCX5FO93jSjPa7gKsBvQF",
          grant_type: "refresh_token",
          device_id: localStorage.getItem("deviceId"),
          device_type: getDeviceType(),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("Refresh Access Token Response:", response.data);
      localStorage.setItem("@user", response.data.access_token);
      localStorage.setItem("@userRefreshToken", response.data.refresh_token);
      return response.data;
    } catch (error) {
      console.error("Error fetching access token:", error);
      // localStorage.removeItem("@user");
      // localStorage.removeItem("@userRefreshToken");
      throw error;
    }
  }

  // useEffect(() => {
  //   if (refresh_token) {
  //     const RToken = getAccessToken();
  //   }
  // }, [refresh_token]);

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(
        "https://htprdapi.hightable.ai/profile-members/profile",
        {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // console.log("Profile Data:", response.data.data);
      localStorage.setItem("@userAccount", response.data.data.id);
      localStorage.setItem("@userName", response.data.data.first_name);
      localStorage.setItem("@userPhone", response.data.data.phone);
      localStorage.setItem("@userPhoto", response.data.data.photo);
      localStorage.setItem("email", response.data.data.email);
    } catch (error) {
      console.error("Failed to fetch profile data:", error);
      localStorage.removeItem("@user");
      localStorage.removeItem("@userRefreshToken");
      localStorage.removeItem("@userName");
      localStorage.removeItem("@userPhone");
      localStorage.removeItem("@userAccount");
      localStorage.removeItem("@userPhoto");
    }
  };

  // useEffect(() => {
  //   if (accessToken) {
  //     fetchProfileData();
  //   }
  // }, []);

  // Schedule token refresh before expiry
  function scheduleTokenRefresh() {
    const expiry = localStorage.getItem("@tokenExpiry");
    console.log("=========> scheduleTokenRefresh", expiry);
    if (expiry) {
      const timeLeft = expiry - Date.now();
      if (timeLeft > 0) {
        setTimeout(getAccessToken, timeLeft);
      } else {
        getAccessToken(); // Expired, refresh immediately
      }
    }
  }

  // Call this function only once when the app loads
  // function initializeTokenRefresh() {
  //   if (refresh_token && accessToken) {
  //     scheduleTokenRefresh();
  //   }
  // }

  // useEffect(() => {
  //   if (accessToken) {
  //     // Initialize token refresh on app load
  //     initializeTokenRefresh();
  //   }
  // }, []);

  return (
    <Helmet>
      <title>HighTable</title>
      <title>HighTable | Dine with a small bunch of strangers</title>
      <meta
        name="description"
        content="An app that gives you a seat to meet, connect, and bond face to face over the most prestigious setting of all. A Table."
      />
      <meta property="og:title" content="HighTable" />
      <meta
        property="og:description"
        content="An app that gives you a seat to meet, connect, and bond face to face over the most prestigious setting of all. A Table."
      />
      <meta
        property="og:image"
        content="https://kwad.in/hightable/img/hightableog.jpg"
      />
      <meta property="twitter:title" content="HighTable" />
      <meta
        property="twitter:description"
        content="An app that gives you a seat to meet, connect, and bond face to face over the most prestigious setting of all. A Table."
      />
      <meta
        property="twitter:image"
        content="https://kwad.in/hightable/img/hightableog.jpg"
      />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="generator" content="Webflow" />
      <link href="https://fonts.googleapis.com" rel="preconnect" />
      <link
        href="https://fonts.gstatic.com"
        rel="preconnect"
        crossOrigin="anonymous"
      />
    </Helmet>
  );
};

export default Head;
